import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";

import { H1 } from "../components/h1";
import { Layout } from "../components/layout";
import { ShoppingList } from "../components/shopping-list";
import { WeeklyDinner } from "../components/weekly-dinner";

export function Shopping() {
  const [activeTab, setActiveTab] = useState<"shopping" | "weekly-dinner">(
    "shopping",
  );

  const path = useLocation();
  const pathname = path.pathname;

  useEffect(() => {
    if (pathname.includes("cart")) {
      setActiveTab("shopping");
    } else if (pathname.includes("dinner")) {
      setActiveTab("weekly-dinner");
    }
  }, [pathname]);

  return (
    <Layout>
      <div className="w-full mx-auto p-4">
        <H1 className="mb-6">Shopping Cart</H1>
        <div className="flex flex-row justify-between mb-4 lg:hidden">
          <NavLink
            className={`w-1/2 text-center !rounded-none !bg-transparent focus:!shadow-none !border-b-2 !border-t-0 !border-x-0  ${activeTab === "shopping" ? "!border-b-gray-500 !text-black" : "!border-b-gray-300 !text-gray-500"}`}
            to="/shopping/cart"
            onClick={() => setActiveTab("shopping")}
          >
            Shopping List
          </NavLink>
          <NavLink
            className={`w-1/2 text-center !rounded-none !bg-transparent focus:!shadow-none !border-b-2 !border-t-0 !border-x-0 ${activeTab === "weekly-dinner" ? "!border-b-gray-500 !text-black" : "!border-b-gray-300 !text-gray-500"}`}
            to="/shopping/dinner"
            onClick={() => setActiveTab("weekly-dinner")}
          >
            Weekly Dinner
          </NavLink>
        </div>
        <div className="flex flex-row gap-4 justify-between">
          <ShoppingList
            className={`w-full lg:w-1/2 ${activeTab === "shopping" ? "block" : "hidden"} lg:block`}
          />
          <WeeklyDinner
            className={`w-full lg:w-1/2 ${activeTab === "weekly-dinner" ? "block" : "hidden"} lg:block`}
          />
        </div>
      </div>
    </Layout>
  );
}
